import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Candidates from "@/pages/Candidates";
import CandidateDetail from "@/pages/CandidateDetail";
import TeamAdmin from "@/pages/TeamAdmin";
import Insights from "@/pages/Insights";
import Placements from "@/pages/Placements";
import Settings from "@/pages/Settings";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import AcceptInvite from "@/pages/AcceptInvite";
import { Toaster } from "sonner";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
          <Route path="/candidates" element={<Shell><Candidates /></Shell>} />
          <Route path="/candidates/:id" element={<Shell><CandidateDetail /></Shell>} />
          <Route path="/clients" element={<Shell><Clients /></Shell>} />
          <Route path="/clients/:id" element={<Shell><ClientDetail /></Shell>} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/team" element={<Shell><TeamAdmin /></Shell>} />
          <Route path="/insights" element={<Shell><Insights /></Shell>} />
          <Route path="/placements" element={<Shell><Placements /></Shell>} />
          <Route path="/settings" element={<Shell><Settings /></Shell>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
